
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("8j9VY", function(module, exports) {
$parcel$export(module.exports, "default", () => $0822a3785a204258$export$2e2bcd8739ae039);


var $hF7dB = parcelRequire("hF7dB");


var $9uTsJ = parcelRequire("9uTsJ");

var $0822a3785a204258$export$2e2bcd8739ae039 = (0, $9uTsJ.default);

});

parcelRegister("fVnHQ", function(module, exports) {
const $6401e7acd2e74df8$export$5b956b542f1bc1b3 = 800;
const $6401e7acd2e74df8$export$89a9f35a94d7f196 = 200;
module.exports["DELAY_MS_SHOW"] = $6401e7acd2e74df8$export$5b956b542f1bc1b3;
module.exports["DELAY_MS_HIDE"] = $6401e7acd2e74df8$export$89a9f35a94d7f196;

});

parcelRegister("hF7dB", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $14151ca210c57240$export$403d297463f226af = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("dcyNp")));
module.exports["ProfileCardLazy"] = $14151ca210c57240$export$403d297463f226af;

});

parcelRegister("dcyNp", function(module, exports) {

let $99c7631a4c3775b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $99c7631a4c3775b5$var$load("az9CK"),
    $99c7631a4c3775b5$var$load("597JT"),
    $99c7631a4c3775b5$var$load("8OVpV"),
    $99c7631a4c3775b5$var$load("6wr18"),
    $99c7631a4c3775b5$var$load("cHQ50"),
    $99c7631a4c3775b5$var$load("2XikM"),
    $99c7631a4c3775b5$var$load("Wowvf"),
    $99c7631a4c3775b5$var$load("dRpV3"),
    $99c7631a4c3775b5$var$load("ffEVr"),
    $99c7631a4c3775b5$var$load("7EorR"),
    $99c7631a4c3775b5$var$load("dTsOE"),
    $99c7631a4c3775b5$var$load("hhss7"),
    $99c7631a4c3775b5$var$load("kSjKH")
]).then(()=>parcelRequire('f12Eo'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("9uTsJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5942c2aa812a2515$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $iK7QL = parcelRequire("iK7QL");

var $9EUfN = parcelRequire("9EUfN");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $fDXXi = parcelRequire("fDXXi");


var $dTk3A = parcelRequire("dTk3A");


var $81aSu = parcelRequire("81aSu");


var $cgtv4 = parcelRequire("cgtv4");

const $201409dad5c676c1$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($201409dad5c676c1$var$messages.label, {
        fullName: fullName
    }) : formatMessage($201409dad5c676c1$var$messages.fallbackLabel);
};
const $201409dad5c676c1$var$messages = (0, $cgtv4.defineMessages)({
    fallbackLabel: {
        id: "profilecard.user.trigger.fallback-aria-label",
        defaultMessage: "More information about this user"
    },
    label: {
        id: "profilecard.user.trigger.aria-label",
        defaultMessage: "More information about {fullName}"
    }
});
var $201409dad5c676c1$export$2e2bcd8739ae039 = $201409dad5c676c1$var$getLabelMessage;



var $lAwme = parcelRequire("lAwme");


var $bUp2E = parcelRequire("bUp2E");


var $fVnHQ = parcelRequire("fVnHQ");


var $caPHA = parcelRequire("caPHA");











var $dWjpO = parcelRequire("dWjpO");


var $ay6Zz = parcelRequire("ay6Zz");





var $3H8bj = parcelRequire("3H8bj");


var $exN3e = parcelRequire("exN3e");


var $lFfRz = parcelRequire("lFfRz");


var $joVWg = parcelRequire("joVWg");

const $92606fc73eb2626b$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $42omo.useState)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const creatorUserId = (0, $42omo.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $3H8bj.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const { href: profileHref } = (0, $ay6Zz.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    /**
	 * @TODO replace with `getAgentCreator` from `@atlassian/rovo-agent-components`
	 * @deprecated use `getAgentCreator` from `@atlassian/rovo-agent-components`
	 */ const getCreatorDeprecated = (0, $42omo.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    if (authoringTeam) return {
                        type: 'CUSTOMER',
                        name: authoringTeam.displayName ?? '',
                        profileLink: authoringTeam.profileUrl ?? ''
                    };
                    const creatorInfo = await props.resourceClient.getProfile(props.cloudId, creatorUserId, fireEvent);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch  {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const getCreator = (0, $42omo.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            if (creatorUserId && props.cloudId) userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, creatorUserId, fireEvent);
            const creatorInfo = (0, $dWjpO.getAgentCreator)({
                creatorType: creator_type ?? '',
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${creatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        creatorUserId,
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            if ((0, $dh538.fg)('rovo_agent_show_creator_on_profile_card_fix')) {
                const agentCreatorInfo = await getCreator(creatorInfoProps);
                setAgentData({
                    ...profileData,
                    creatorInfo: agentCreatorInfo
                });
            } else {
                const agentCreatorInfoDeprecated = await getCreatorDeprecated(creatorInfoProps);
                setAgentData({
                    ...profileData,
                    creatorInfo: agentCreatorInfoDeprecated
                });
            }
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient,
        getCreatorDeprecated
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lFfRz.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $exN3e.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $joVWg.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer
        })
    });
};



var $hF7dB = parcelRequire("hF7dB");








var $9hlns = parcelRequire("9hlns");










const $b659668b6bbe5304$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $42omo.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.spinner', {
            firedAt: Math.round((0, $caPHA.getPageTime)()),
            ...(0, $bUp2E.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAwme.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {})
    });
};
var $b659668b6bbe5304$export$2e2bcd8739ae039 = $b659668b6bbe5304$var$UserLoadingState;


function $5942c2aa812a2515$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, trigger: trigger, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag, hideAgentMoreActions: hideAgentMoreActions, hideAiDisclaimer: hideAiDisclaimer }) {
    if (isAgent) return /*#__PURE__*/ (0, $l998X.jsx)((0, $92606fc73eb2626b$export$4b013ffffcb40af8), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        trigger: trigger,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag,
        hideMoreActions: (0, $dh538.fg)('jira_ai_profilecard_hide_agent_actions') && !!hideAgentMoreActions,
        hideAiDisclaimer: hideAiDisclaimer
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hF7dB.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $5942c2aa812a2515$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, hideAgentMoreActions: hideAgentMoreActions, hideAiDisclaimer: hideAiDisclaimer, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible, ssrPlaceholderId: ssrPlaceholderId, showDelay: customShowDelay, hideDelay: customHideDelay }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isMounted = (0, $42omo.useRef)(false);
    const [visible, setVisible] = (0, $42omo.useState)(false);
    const showTimer = (0, $42omo.useRef)(0);
    const hideTimer = (0, $42omo.useRef)(0);
    const isExternalControl = propsIsVisible !== undefined && propsIsVisible !== visible;
    const showDelay = trigger === 'click' || isExternalControl && (0, $dh538.fg)('fix_profilecard_trigger_isvisible') ? 0 : customShowDelay ?? (0, $fVnHQ.DELAY_MS_SHOW);
    const hideDelay = trigger === 'click' || isExternalControl && (0, $dh538.fg)('fix_profilecard_trigger_isvisible') ? 0 : customHideDelay ?? (0, $fVnHQ.DELAY_MS_HIDE);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(undefined);
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const [data, setData] = (0, $42omo.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $42omo.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $42omo.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $42omo.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $42omo.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const triggerRef = (0, $42omo.useRef)(null);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $42omo.useCallback)((eventKey, ...attributes)=>{
        if (!isMounted.current) return;
        fireEvent(eventKey, ...attributes);
    }, [
        fireEvent
    ]);
    const hideProfilecard = (0, $42omo.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $42omo.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $42omo.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $42omo.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $42omo.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $42omo.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $42omo.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics('ui.profilecard.triggered', {
            method: 'click',
            firedAt: Math.round((0, $caPHA.getPageTime)()),
            ...(0, $bUp2E.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics('ui.profilecard.triggered', {
            method: 'hover',
            firedAt: Math.round((0, $caPHA.getPageTime)()),
            ...(0, $bUp2E.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics('ui.profilecard.triggered', {
                method: 'click',
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $42omo.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $dh538.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $42omo.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $42omo.useCallback)(()=>{
        return (0, $81aSu.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $42omo.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    const ssrPlaceholderProp = ssrPlaceholderId ? {
        'data-ssr-placeholder-replace': ssrPlaceholderId
    } : {};
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $l998X.jsx)($5942c2aa812a2515$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $l998X.jsx)($5942c2aa812a2515$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag,
                            hideAgentMoreActions: hideAgentMoreActions,
                            hideAiDisclaimer: hideAiDisclaimer
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $201409dad5c676c1$export$2e2bcd8739ae039)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        ...ssrPlaceholderProp,
                        children: children
                    });
                },
                zIndex: (0, $dTk3A.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $dh538.fg)('enable_appropriate_reading_order_in_profile_card'),
                shouldDisableFocusLock: (0, $dh538.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iK7QL.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $9EUfN.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $5942c2aa812a2515$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAwme.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b659668b6bbe5304$export$2e2bcd8739ae039), {
            fireAnalytics: fireAnalytics
        })
    });

});

parcelRegister("iK7QL", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $f28ce8dc3985e647$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("b9ThN")));
module.exports["GiveKudosLauncherLazy"] = $f28ce8dc3985e647$export$93fe397a02fe8b76;

});

parcelRegister("b9ThN", function(module, exports) {

let $81fb6ba100af593d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81fb6ba100af593d$var$load("6wr18"),
    $81fb6ba100af593d$var$load("ffEVr"),
    $81fb6ba100af593d$var$load("hhss7"),
    $81fb6ba100af593d$var$load("1Y6tF")
]).then(()=>parcelRequire('b3HrA'));

});

parcelRegister("9EUfN", function(module, exports) {
var $6a667c4b16202b21$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $6a667c4b16202b21$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $6a667c4b16202b21$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($6a667c4b16202b21$export$d21f9befaa2961a).includes(value);
};
module.exports["KudosType"] = $6a667c4b16202b21$export$4fa2020056771264;
module.exports["FlagEventType"] = $6a667c4b16202b21$export$d21f9befaa2961a;
module.exports["isFlagEventTypeValue"] = $6a667c4b16202b21$export$7a1fc1a1b0477464;

});

parcelRegister("fDXXi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::d01fef63886f2825ffbc3a0ec1ca7534>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $10cdf05152c4d491$export$3f072f06b90c3985 = 'peopleTeams';


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::050566410df453c9b1ba071c6805ead2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ const $0ce3610ad559befd$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $0ce3610ad559befd$export$2e2bcd8739ae039 = $0ce3610ad559befd$var$createEventPayload;


const $e5e4133608950b34$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $0ce3610ad559befd$export$2e2bcd8739ae039)(...params));
        event.fire((0, $10cdf05152c4d491$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $e5e4133608950b34$export$5bf35293e545f20c;

});

parcelRegister("81aSu", function(module, exports) {
const $d60d4b660fa77e33$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $d60d4b660fa77e33$export$2e2bcd8739ae039 = $d60d4b660fa77e33$var$filterActions;
module.exports["default"] = $d60d4b660fa77e33$export$2e2bcd8739ae039;

});

parcelRegister("lAwme", function(module, exports) {
/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ // PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $edcda65ecf49642b$var$styles = {
    cardWrapper: "_2rko12b0 _1bsb1gwv",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
const $edcda65ecf49642b$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($edcda65ecf49642b$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        "aria-label": ariaLabel,
        children: children
    });
const $edcda65ecf49642b$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: testId,
        xcss: (0, $1Whri.cx)($edcda65ecf49642b$var$styles.spinnerContainer),
        children: children
    });
module.exports["CardWrapper"] = $edcda65ecf49642b$export$6aa22a823032b784;
module.exports["SpinnerContainer"] = $edcda65ecf49642b$export$a5e06607a5ac6158;

});

parcelRegister("bUp2E", function(module, exports) {

var $caPHA = parcelRequire("caPHA");

/** Below lines are copied from teams common analytics */ const $4ebff2946cad2a83$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $4ebff2946cad2a83$export$849551cf61929d4f = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4ebff2946cad2a83$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $4ebff2946cad2a83$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $4ebff2946cad2a83$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($4ebff2946cad2a83$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $4ebff2946cad2a83$var$TEAM_SUBJECT = 'teamProfileCard';
const $4ebff2946cad2a83$var$USER_SUBJECT = 'profilecard';
const $4ebff2946cad2a83$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */ const $4ebff2946cad2a83$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $caPHA.getPageTime)())
        }
    });
const $4ebff2946cad2a83$export$6f40cdf6d42c018d = (type)=>{
    switch(type){
        case 'user':
            return $4ebff2946cad2a83$var$USER_SUBJECT;
        case 'team':
            return $4ebff2946cad2a83$var$TEAM_SUBJECT;
        case 'agent':
            return $4ebff2946cad2a83$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $4ebff2946cad2a83$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $4ebff2946cad2a83$var$createEvent('ui', 'triggered', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $4ebff2946cad2a83$export$c9b0e37b229a297b = (action, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$TEAM_SUBJECT, 'request', attributes);
const $4ebff2946cad2a83$export$12dae48763368ac9 = (action, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$USER_SUBJECT, 'request', attributes);
const $4ebff2946cad2a83$export$41816a317479160b = (type, actionSubjectId, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'rendered', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), actionSubjectId, attributes);
const $4ebff2946cad2a83$export$fdcd134fbeb1f921 = (type, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), 'action', attributes);
const $4ebff2946cad2a83$export$93260987012593be = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$USER_SUBJECT, 'reportingLines', attributes);
const $4ebff2946cad2a83$export$79befd155063a6a7 = (type, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), 'moreActions', attributes);
const $4ebff2946cad2a83$export$2703289b35687fde = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'avatar', attributes);
const $4ebff2946cad2a83$export$b4411a7661cf2d3f = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $4ebff2946cad2a83$export$c86679da702d560e = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $4ebff2946cad2a83$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);
module.exports["PACKAGE_META_DATA"] = $4ebff2946cad2a83$export$849551cf61929d4f;
module.exports["fireEvent"] = $4ebff2946cad2a83$export$43835e9acf248a15;
module.exports["getActionSubject"] = $4ebff2946cad2a83$export$6f40cdf6d42c018d;
module.exports["cardTriggered"] = $4ebff2946cad2a83$export$d50ab8a3b6975c;
module.exports["profileCardRendered"] = $4ebff2946cad2a83$export$41816a317479160b;
module.exports["actionClicked"] = $4ebff2946cad2a83$export$fdcd134fbeb1f921;
module.exports["reportingLinesClicked"] = $4ebff2946cad2a83$export$93260987012593be;
module.exports["moreActionsClicked"] = $4ebff2946cad2a83$export$79befd155063a6a7;
module.exports["teamAvatarClicked"] = $4ebff2946cad2a83$export$2703289b35687fde;
module.exports["moreMembersClicked"] = $4ebff2946cad2a83$export$b4411a7661cf2d3f;
module.exports["errorRetryClicked"] = $4ebff2946cad2a83$export$c86679da702d560e;

});

parcelRegister("caPHA", function(module, exports) {
const $156cb4b98a287aa0$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $156cb4b98a287aa0$var$performanceAvailable = $156cb4b98a287aa0$var$isPerformanceAvailable();
const $156cb4b98a287aa0$var$initialPageTime = Date.now();
const $156cb4b98a287aa0$export$e9faea7c41053334 = ()=>{
    if ($156cb4b98a287aa0$var$performanceAvailable) return performance.now();
    return Date.now() - $156cb4b98a287aa0$var$initialPageTime;
};
module.exports["getPageTime"] = $156cb4b98a287aa0$export$e9faea7c41053334;

});

parcelRegister("dWjpO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");


var $3gadb = parcelRequire("3gadb");


var $f3WwA = parcelRequire("f3WwA");


var $99GMb = parcelRequire("99GMb");


var $cgtv4 = parcelRequire("cgtv4");

const $f1c180459da2c1cd$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});


const $c7d46d6df90d8d02$var$styles = {
    clickableItem: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    name: "_1bah1yb4 _4cvr1y6m",
    description: "_19pkze3t _otyru2gc _1i4qfg65 _1nmz1hna",
    descriptionRefresh: "_1mouze3t _1i4qfg65 _1nmz1hna",
    wrapper: "_otyru2gc",
    tooltipWrapper: "_195gu2gc _1e0c116y _kqswh2mm _94n5v77o",
    headingWrapper: "_kqswh2mm",
    headingContentWrapper: "_195gu2gc"
};
const $c7d46d6df90d8d02$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
     // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    if (creatorType === 'FORGE' || creatorType === 'THIRD_PARTY') return {
        type: 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $c7d46d6df90d8d02$export$f35b2eeaa7e3db15 = ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $f1c180459da2c1cd$export$defe85febe8b728c).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100,
                borderRadius: 3
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $f1c180459da2c1cd$export$defe85febe8b728c).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                testId: "atlassian-icon",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                        label: "",
                        size: "small",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: "Atlassian"
                    })
                ]
            })
        });
        if (creator.type === 'CUSTOMER') return formatMessage((0, $f1c180459da2c1cd$export$defe85febe8b728c).agentCreatedBy, {
            creatorNameWithLink: (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__ai-mate') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $2Nwuj.default), {
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank",
                children: [
                    creator.name,
                    ' ',
                    creator.status === 'inactive' && formatMessage((0, $f1c180459da2c1cd$export$defe85febe8b728c).agentDeactivated)
                ]
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $l998X.jsxs)("a", {
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank",
                children: [
                    creator.name,
                    ' ',
                    creator.status === 'inactive' && formatMessage((0, $f1c180459da2c1cd$export$defe85febe8b728c).agentDeactivated)
                ]
            })
        });
         // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $f1c180459da2c1cd$export$defe85febe8b728c).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    return creatorRender ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $c7d46d6df90d8d02$var$styles.clickableItem,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                appearance: "brand",
                size: "small"
            }),
            creatorRender
        ]
    }) : null;
};
const $c7d46d6df90d8d02$export$e02348ba0b01a210 = ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.100",
        xcss: (0, $dh538.fg)('rovo_agent_empty_state_refresh') ? null : $c7d46d6df90d8d02$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $c7d46d6df90d8d02$var$styles.name,
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        xcss: $c7d46d6df90d8d02$var$styles.headingWrapper,
                        alignBlock: "end",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                as: "h2",
                                size: (0, $dh538.fg)('rovo_agent_empty_state_refresh') ? 'medium' : 'xlarge',
                                children: agentName
                            }),
                            isHidden && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $c7d46d6df90d8d02$var$styles.tooltipWrapper,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                    content: formatMessage((0, $f1c180459da2c1cd$export$defe85febe8b728c).hiddenTooltip),
                                    position: "top",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f3WwA.HiddenIcon), {
                                        label: formatMessage((0, $f1c180459da2c1cd$export$defe85febe8b728c).hiddenIcon)
                                    })
                                })
                            }),
                            headingRender && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $c7d46d6df90d8d02$var$styles.headingContentWrapper,
                                children: headingRender
                            })
                        ]
                    }),
                    showStarButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $99GMb.StarIconButton), {
                        isStarred: isStarred,
                        handleToggle: onStarToggle
                    })
                ]
            }),
            creatorRender,
            !!agentDescription && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $dh538.fg)('rovo_agent_empty_state_refresh') ? $c7d46d6df90d8d02$var$styles.descriptionRefresh : $c7d46d6df90d8d02$var$styles.description,
                as: "p",
                children: agentDescription
            }),
            starCountRender
        ]
    });
};
module.exports["getAgentCreator"] = $c7d46d6df90d8d02$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $c7d46d6df90d8d02$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $c7d46d6df90d8d02$export$e02348ba0b01a210;

});

parcelRegister("f3WwA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aRCWA = parcelRequire("aRCWA");

const $b7d9c8d9c2bd0031$export$bce21421c351deb1 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aRCWA))), {
        ...props
    });
module.exports["HiddenIcon"] = $b7d9c8d9c2bd0031$export$bce21421c351deb1;

});

parcelRegister("99GMb", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $gI8uy = parcelRequire("gI8uy");


var $kfYj7 = parcelRequire("kfYj7");


var $fVUfS = parcelRequire("fVUfS");


var $cgtv4 = parcelRequire("cgtv4");

var $89ec1a82fbe0f7cb$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Not favourited, click to favourite"
    }
});


const $1eedb87b7dc29dd4$var$styles = {
    pressableStarIcon: "_bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4t3i1tcg _1bsb1tcg",
    hidden: "_tzy4idpf"
};
const $1eedb87b7dc29dd4$export$703abb8bd2abdfa5 = ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($1eedb87b7dc29dd4$var$styles.pressableStarIcon, !visible && $1eedb87b7dc29dd4$var$styles.hidden),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: isStarred || isHovered ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
            spacing: "spacious",
            label: formatMessage((0, $89ec1a82fbe0f7cb$export$2e2bcd8739ae039).removeFromFavouritesLabel),
            color: "var(--ds-icon-accent-orange, #E06C00)"
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
            spacing: "spacious",
            label: formatMessage((0, $89ec1a82fbe0f7cb$export$2e2bcd8739ae039).clickToFavouriteLabel),
            color: "var(--ds-icon, #292A2E)"
        })
    });
};
module.exports["StarIconButton"] = $1eedb87b7dc29dd4$export$703abb8bd2abdfa5;

});

parcelRegister("ay6Zz", function(module, exports) {

var $hbEOA = parcelRequire("hbEOA");


var $dedJV = parcelRequire("dedJV");

var $lzcvT = parcelRequire("lzcvT");


var $dh538 = parcelRequire("dh538");

function $de931ea679eb206a$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}
const $de931ea679eb206a$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');
const $de931ea679eb206a$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
const $de931ea679eb206a$export$f710a83a91838a36 = ()=>globalThis.location?.origin;
const $de931ea679eb206a$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;





function $60149519f75ae663$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $lzcvT.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${$60149519f75ae663$export$a9f2c34176fff494() ? '.stg' : ''}.atlassian-us-gov-mod.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    return `${(0, $dedJV.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
function $60149519f75ae663$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    if ((0, $hbEOA.isTeamsAppEnabled)(config) || config.hostProduct === 'home' || !config.hostProduct) return $60149519f75ae663$export$9665cb78fbba2c92(path, config, query, anchor);
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    return `${(0, $de931ea679eb206a$export$f710a83a91838a36)()}/${config.hostProduct === 'confluence' ? 'wiki' : 'jira'}/people/${path}${queryString}`;
}
const $60149519f75ae663$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if ((0, $hbEOA.isTeamsAppEnabled)(config)) {
            if (config.shouldOpenInSameTab) {
                (0, $de931ea679eb206a$export$89e12c5b50f7529d)(href);
                return;
            }
            (0, $de931ea679eb206a$export$9e52b10d57ddf9e3)(href);
            return;
        } else if (config.shouldOpenInSameTab) {
            if (config.push) {
                config.push(href);
                return;
            }
            (0, $de931ea679eb206a$export$89e12c5b50f7529d)(href);
            return;
        } else {
            (0, $de931ea679eb206a$export$9e52b10d57ddf9e3)(href);
            return;
        }
    };
function $60149519f75ae663$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $60149519f75ae663$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!action.payload?.userId) return {
                path: ''
            };
            return {
                path: `${$60149519f75ae663$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!action.payload?.teamId) return {
                path: ''
            };
            return {
                path: `team/${$60149519f75ae663$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!action.payload?.agentId) return {
                path: ''
            };
            return {
                path: `agent/${$60149519f75ae663$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!action.payload?.kudosId) return {
                path: ''
            };
            return {
                path: `kudos/${$60149519f75ae663$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            if ((0, $dh538.fg)('enable_teams_app_breadcrumb_respect_directories')) return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_PEOPLE'
                })
            };
            return {
                path: `search/people`,
                query: new URLSearchParams(action.payload.query)
            };
        case 'USER_WORK':
            return {
                path: `${$60149519f75ae663$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}
function $60149519f75ae663$export$a9f2c34176fff494() {
    const host = (0, $de931ea679eb206a$export$640106f6dc7d2706)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    // *.atlassian-stg-fedm.net
    if (host.match(/atlassian-stg-fedm\.net/) && (0, $dh538.fg)('teams-app-fedramp-stg-fedm-hostname-support')) return true;
    return false;
}
function $60149519f75ae663$export$a792d22ca73cc3ca() {
    const path = (0, $de931ea679eb206a$export$7333db99aa99d383)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $de931ea679eb206a$export$640106f6dc7d2706)().startsWith('home')) return 'home';
    return undefined;
}


const $633b38b742596343$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
		 * If teams app is enabled, default to opening in new tab.
		 */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !(0, $hbEOA.isTeamsAppEnabled)(action) : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $60149519f75ae663$export$a792d22ca73cc3ca)()
    };
    const { path: path, query: query } = (0, $60149519f75ae663$export$b406f12e2156b3fe)(actionWithDefaults);
    const href = (0, $60149519f75ae663$export$82476f982757e71e)(path, actionWithDefaults, query);
    const onNavigate = (0, $60149519f75ae663$export$39f25014273b0a58)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
const $633b38b742596343$export$196b2cec97b1c87c = (path, search, config)=>{
    return (0, $60149519f75ae663$export$9665cb78fbba2c92)(path, config, new URLSearchParams(search));
};
module.exports["navigateToTeamsApp"] = $633b38b742596343$export$cd99a4ca8e852372;
module.exports["toTeamsAppURL"] = $633b38b742596343$export$196b2cec97b1c87c;

});

parcelRegister("hbEOA", function(module, exports) {

var $T9xHm = parcelRequire("T9xHm");

function $78a8b41df0483efe$export$5921b2a93a401547(_config) {
    //  Hard kill switch for isolated cloud until Standalone directory is deployed
    if ((0, $T9xHm.isIsolatedCloud)()) return false;
    return true;
}
module.exports["isTeamsAppEnabled"] = $78a8b41df0483efe$export$5921b2a93a401547;

});

parcelRegister("dedJV", function(module, exports) {

var $g46Dm = parcelRequire("g46Dm");




const $dbc5bb16ecb06da9$export$6836b090dbaa813a = {
    [(0, $g46Dm.COMMERCIAL)]: {
        [(0, $g46Dm.STAGING)]: 'stg.atlassian.com',
        [(0, $g46Dm.PRODUCTION)]: 'atlassian.com'
    },
    [(0, $g46Dm.FEDRAMP_FEDEX)]: {
        [(0, $g46Dm.STAGING)]: 'atlassian-fex.com'
    },
    [(0, $g46Dm.FEDRAMP_MODERATE)]: {
        [(0, $g46Dm.STAGING)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $g46Dm.PRODUCTION)]: 'atlassian-us-gov-mod.com'
    }
};
const $dbc5bb16ecb06da9$export$c6ab20d0ac4d06b2 = {};
const $dbc5bb16ecb06da9$export$4723232b625f823e = {
    analytics: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'start.atlassian.com',
            [(0, $g46Dm.STAGING)]: 'start.stg.atlassian.com'
        },
        [(0, $g46Dm.FEDRAMP_MODERATE)]: {
            [(0, $g46Dm.PRODUCTION)]: 'start.atlassian-us-gov-mod.com',
            [(0, $g46Dm.STAGING)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'id.atlassian.com',
            [(0, $g46Dm.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $g46Dm.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $g46Dm.FEDRAMP_MODERATE)]: {
            [(0, $g46Dm.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $g46Dm.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $g46Dm.COMMERCIAL)]: {
            [(0, $g46Dm.PRODUCTION)]: 'support.atlassian.com'
        }
    }
};


/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $7584f40bea5ad330$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];


function $79ec0654a66dd5c6$export$8d21e34596265fa2(data) {
    if (!data || Object.keys(data).length < 1) throw new Error('Data are not available');
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    globalThis.ATL_CONTEXT_DOMAIN = data;
}
function $79ec0654a66dd5c6$var$isValidDomainKey(domainKey) {
    if (!(0, $7584f40bea5ad330$export$b450288891b9771b).includes(domainKey)) return false;
    return true;
}
function $79ec0654a66dd5c6$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$79ec0654a66dd5c6$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $7584f40bea5ad330$export$b450288891b9771b).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? $79ec0654a66dd5c6$export$509d18a5fd824839();
    // Second priority, return if there is a full domain override
    const override = (0, $dbc5bb16ecb06da9$export$4723232b625f823e)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? override[0, $g46Dm.COMMERCIAL][0, $g46Dm.PRODUCTION] // Fallback to mandatory commercial production
    );
    // Third priority, join the subdomain
    const tld = (0, $dbc5bb16ecb06da9$export$6836b090dbaa813a)[perimeter]?.[env] ?? (0, $dbc5bb16ecb06da9$export$6836b090dbaa813a)[0, $g46Dm.COMMERCIAL][0, $g46Dm.PRODUCTION];
    const subdomain = (0, $dbc5bb16ecb06da9$export$c6ab20d0ac4d06b2)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}
function $79ec0654a66dd5c6$export$45d6512913ef41b4(domain) {
    return `${globalThis.location.protocol}//${$79ec0654a66dd5c6$export$b5ce351acdc48c2a(domain)}`;
}
function $79ec0654a66dd5c6$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $g46Dm.PRODUCTION),
        (0, $g46Dm.COMMERCIAL)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $g46Dm.STAGING),
        (0, $g46Dm.FEDRAMP_FEDEX)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $g46Dm.STAGING),
        (0, $g46Dm.FEDRAMP_MODERATE)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $g46Dm.STAGING),
        (0, $g46Dm.FEDRAMP_MODERATE)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $g46Dm.PRODUCTION),
        (0, $g46Dm.FEDRAMP_MODERATE)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $g46Dm.STAGING),
        (0, $g46Dm.COMMERCIAL)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $g46Dm.STAGING),
        (0, $g46Dm.COMMERCIAL)
    ];
    // default fallthrough
    return [
        (0, $g46Dm.PRODUCTION),
        (0, $g46Dm.COMMERCIAL)
    ];
}
module.exports["getATLContextDomain"] = $79ec0654a66dd5c6$export$b5ce351acdc48c2a;
module.exports["getATLContextUrl"] = $79ec0654a66dd5c6$export$45d6512913ef41b4;

});

parcelRegister("3H8bj", function(module, exports) {
const $7dc5183756e8ff90$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $7dc5183756e8ff90$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($7dc5183756e8ff90$export$470b0d72e4fdc43a, '');
};
module.exports["getAAIDFromARI"] = $7dc5183756e8ff90$export$3761e66a04602cbd;

});

parcelRegister("exN3e", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $ccHMk = parcelRequire("ccHMk");


var $7yDmn = parcelRequire("7yDmn");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $2qY37 = parcelRequire("2qY37");


var $aHGHx = parcelRequire("aHGHx");


var $bUp2E = parcelRequire("bUp2E");

const $bcf90d0eb3671370$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $42omo.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $bUp2E.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $l998X.jsx)((0, $aHGHx.ErrorTitle), {
            children: (0, $dh538.fg)('people-teams-fix-no-literal-string-in-jsx') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $2qY37.default).errorUserNotFound
            }) : 'The user is no longer available for the site'
        });
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $aHGHx.ErrorTitle), {
            children: [
                (0, $dh538.fg)('people-teams-fix-no-literal-string-in-jsx') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $2qY37.default).errorGeneric
                }) : "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $l998X.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    children: (0, $dh538.fg)('people-teams-fix-no-literal-string-in-jsx') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $2qY37.default).errorRetrySuggestion
                    }) : "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $aHGHx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                onClick: reload,
                children: (0, $dh538.fg)('people-teams-fix-no-literal-string-in-jsx') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $2qY37.default).errorTryAgain
                }) : 'Try again'
            })
        ]
    });
};
var $bcf90d0eb3671370$export$2e2bcd8739ae039 = $bcf90d0eb3671370$var$ErrorMessage;
module.exports["default"] = $bcf90d0eb3671370$export$2e2bcd8739ae039;

});

parcelRegister("2qY37", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $118484dfd30546b5$var$messages = (0, $cgtv4.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    }
});
var $118484dfd30546b5$export$2e2bcd8739ae039 = $118484dfd30546b5$var$messages;
module.exports["default"] = $118484dfd30546b5$export$2e2bcd8739ae039;

});

parcelRegister("aHGHx", function(module, exports) {
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");

const $5321d44dec43675e$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_19pku2gc",
    teamErrorText: "_syaz1rpy _19pku2gc"
};
const $5321d44dec43675e$export$bb27b7e39840238f = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($5321d44dec43675e$var$styles.errorWrapper),
        ...props
    });
const $5321d44dec43675e$export$b065fd053267ec81 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $5321d44dec43675e$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            color: "color.text",
            children: props.children
        })
    });
const $5321d44dec43675e$export$90d92ccfb27352c6 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($5321d44dec43675e$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $5321d44dec43675e$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $5321d44dec43675e$export$b065fd053267ec81;
module.exports["TeamErrorText"] = $5321d44dec43675e$export$90d92ccfb27352c6;

});

parcelRegister("lFfRz", function(module, exports) {
/* AgentProfileCardWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $50e0a701e5718424$var$styles = {
    wrapper: "_1bsb1gwv"
};
const $50e0a701e5718424$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $50e0a701e5718424$var$styles.wrapper,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $50e0a701e5718424$export$2c6604b50c274e6f;

});

parcelRegister("joVWg", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $2d361b33fb84f723$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("2QeRE")));
module.exports["AgentProfileCardLazy"] = $2d361b33fb84f723$export$ed0ca9c1d49ea0bf;

});

parcelRegister("2QeRE", function(module, exports) {

let $211bf7deb84129e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $211bf7deb84129e1$var$load("cSjCJ"),
    $211bf7deb84129e1$var$load("6wr18"),
    $211bf7deb84129e1$var$load("4USmq"),
    $211bf7deb84129e1$var$load("4lhj9"),
    $211bf7deb84129e1$var$load("7EorR"),
    $211bf7deb84129e1$var$load("dRpV3"),
    $211bf7deb84129e1$var$load("ffEVr"),
    $211bf7deb84129e1$var$load("hhss7"),
    $211bf7deb84129e1$var$load("cGVng")
]).then(()=>parcelRequire('iydPT'));

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("3Vbz9", function(module, exports) {
$parcel$export(module.exports, "format", () => (parcelRequire("lj2T2")).default);
$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("72P30")).default);
$parcel$export(module.exports, "getTimezoneOffset", () => (parcelRequire("arf52")).default);
$parcel$export(module.exports, "toDate", () => (parcelRequire("a7WsF")).default);
$parcel$export(module.exports, "utcToZonedTime", () => (parcelRequire("jcUTC")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

var $lj2T2 = parcelRequire("lj2T2");


var $72P30 = parcelRequire("72P30");


var $arf52 = parcelRequire("arf52");


var $a7WsF = parcelRequire("a7WsF");


var $jcUTC = parcelRequire("jcUTC");



});

parcelRegister("1xmby", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $11ea151386c12b47$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11ea151386c12b47$var$format;

var $11ea151386c12b47$var$_index = $11ea151386c12b47$require$_interopRequireDefault((parcelRequire("cP1bb")));

var $11ea151386c12b47$var$_index2 = $11ea151386c12b47$require$_interopRequireDefault((parcelRequire("eoqCn")));

var $11ea151386c12b47$var$_index3 = $11ea151386c12b47$require$_interopRequireDefault((parcelRequire("g8Sb7")));

var $11ea151386c12b47$var$_index4 = $11ea151386c12b47$require$_interopRequireDefault((parcelRequire("ah1rN")));

var $11ea151386c12b47$var$_index5 = $11ea151386c12b47$require$_interopRequireDefault((parcelRequire("k1iYS")));

var $11ea151386c12b47$var$_index6 = $11ea151386c12b47$require$_interopRequireDefault((parcelRequire("dsDXx")));

var $clMpL = parcelRequire("clMpL");


var $11ea151386c12b47$var$_index8 = $11ea151386c12b47$require$_interopRequireDefault((parcelRequire("9Ip6t")));

var $11ea151386c12b47$var$_index9 = $11ea151386c12b47$require$_interopRequireDefault((parcelRequire("4UaOz")));

var $72yv4 = parcelRequire("72yv4");


var $11ea151386c12b47$var$_index11 = $11ea151386c12b47$require$_interopRequireDefault((parcelRequire("lfpjG")));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $11ea151386c12b47$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $11ea151386c12b47$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $11ea151386c12b47$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $11ea151386c12b47$var$doubleQuoteRegExp = /''/g;
var $11ea151386c12b47$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $11ea151386c12b47$var$format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $11ea151386c12b47$var$_index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $72yv4.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : $11ea151386c12b47$var$_index11.default;
    var firstWeekContainsDate = (0, $11ea151386c12b47$var$_index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $11ea151386c12b47$var$_index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $11ea151386c12b47$var$_index3.default)(dirtyDate);
    if (!(0, $11ea151386c12b47$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $11ea151386c12b47$var$_index6.default)(originalDate);
    var utcDate = (0, $11ea151386c12b47$var$_index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($11ea151386c12b47$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $11ea151386c12b47$var$_index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($11ea151386c12b47$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $11ea151386c12b47$var$cleanEscapedString(substring);
        var formatter = $11ea151386c12b47$var$_index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $clMpL.isProtectedWeekYearToken)(substring)) (0, $clMpL.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $clMpL.isProtectedDayOfYearToken)(substring)) (0, $clMpL.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($11ea151386c12b47$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $11ea151386c12b47$var$cleanEscapedString(input) {
    var matched = input.match($11ea151386c12b47$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($11ea151386c12b47$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});

parcelRegister("cP1bb", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $955b29a1857255e1$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $955b29a1857255e1$var$isValid;

var $955b29a1857255e1$var$_index = $955b29a1857255e1$require$_interopRequireDefault((parcelRequire("hMTHG")));

var $955b29a1857255e1$var$_index2 = $955b29a1857255e1$require$_interopRequireDefault((parcelRequire("g8Sb7")));

var $955b29a1857255e1$var$_index3 = $955b29a1857255e1$require$_interopRequireDefault((parcelRequire("4UaOz")));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $955b29a1857255e1$var$isValid(dirtyDate) {
    (0, $955b29a1857255e1$var$_index3.default)(1, arguments);
    if (!(0, $955b29a1857255e1$var$_index.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $955b29a1857255e1$var$_index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = module.exports.default;

});

parcelRegister("hMTHG", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $cf3220f01f03c58a$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf3220f01f03c58a$var$isDate;

var $cf3220f01f03c58a$var$_typeof2 = $cf3220f01f03c58a$require$_interopRequireDefault((parcelRequire("crVe8")));

var $cf3220f01f03c58a$var$_index = $cf3220f01f03c58a$require$_interopRequireDefault((parcelRequire("4UaOz")));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $cf3220f01f03c58a$var$isDate(value) {
    (0, $cf3220f01f03c58a$var$_index.default)(1, arguments);
    return value instanceof Date || (0, $cf3220f01f03c58a$var$_typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
module.exports = module.exports.default;

});

parcelRegister("4UaOz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3924c7f169f3432d$var$requiredArgs;
function $3924c7f169f3432d$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});

parcelRegister("g8Sb7", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $bc076b627f46288e$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc076b627f46288e$var$toDate;

var $bc076b627f46288e$var$_typeof2 = $bc076b627f46288e$require$_interopRequireDefault((parcelRequire("crVe8")));

var $bc076b627f46288e$var$_index = $bc076b627f46288e$require$_interopRequireDefault((parcelRequire("4UaOz")));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $bc076b627f46288e$var$toDate(argument) {
    (0, $bc076b627f46288e$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $bc076b627f46288e$var$_typeof2.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});

parcelRegister("eoqCn", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $a7a7f45ec76fdf45$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7a7f45ec76fdf45$var$subMilliseconds;

var $a7a7f45ec76fdf45$var$_index = $a7a7f45ec76fdf45$require$_interopRequireDefault((parcelRequire("a6vEq")));

var $a7a7f45ec76fdf45$var$_index2 = $a7a7f45ec76fdf45$require$_interopRequireDefault((parcelRequire("4UaOz")));

var $a7a7f45ec76fdf45$var$_index3 = $a7a7f45ec76fdf45$require$_interopRequireDefault((parcelRequire("9Ip6t")));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $a7a7f45ec76fdf45$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $a7a7f45ec76fdf45$var$_index2.default)(2, arguments);
    var amount = (0, $a7a7f45ec76fdf45$var$_index3.default)(dirtyAmount);
    return (0, $a7a7f45ec76fdf45$var$_index.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});

parcelRegister("a6vEq", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $75b30426b235570f$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $75b30426b235570f$var$addMilliseconds;

var $75b30426b235570f$var$_index = $75b30426b235570f$require$_interopRequireDefault((parcelRequire("9Ip6t")));

var $75b30426b235570f$var$_index2 = $75b30426b235570f$require$_interopRequireDefault((parcelRequire("g8Sb7")));

var $75b30426b235570f$var$_index3 = $75b30426b235570f$require$_interopRequireDefault((parcelRequire("4UaOz")));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $75b30426b235570f$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $75b30426b235570f$var$_index3.default)(2, arguments);
    var timestamp = (0, $75b30426b235570f$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $75b30426b235570f$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});

parcelRegister("9Ip6t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $712bb21c6c7f480f$var$toInteger;
function $712bb21c6c7f480f$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("ah1rN", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $77ac9d4f3f6493d0$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77ac9d4f3f6493d0$var$_index = $77ac9d4f3f6493d0$require$_interopRequireDefault((parcelRequire("bPmt4")));

var $77ac9d4f3f6493d0$var$_index2 = $77ac9d4f3f6493d0$require$_interopRequireDefault((parcelRequire("lz2TJ")));

var $77ac9d4f3f6493d0$var$_index3 = $77ac9d4f3f6493d0$require$_interopRequireDefault((parcelRequire("hyGqb")));

var $77ac9d4f3f6493d0$var$_index4 = $77ac9d4f3f6493d0$require$_interopRequireDefault((parcelRequire("4ovpr")));

var $77ac9d4f3f6493d0$var$_index5 = $77ac9d4f3f6493d0$require$_interopRequireDefault((parcelRequire("cgYRX")));

var $77ac9d4f3f6493d0$var$_index6 = $77ac9d4f3f6493d0$require$_interopRequireDefault((parcelRequire("37kDQ")));

var $77ac9d4f3f6493d0$var$_index7 = $77ac9d4f3f6493d0$require$_interopRequireDefault((parcelRequire("jlCLJ")));
var $77ac9d4f3f6493d0$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $77ac9d4f3f6493d0$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $77ac9d4f3f6493d0$var$_index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $77ac9d4f3f6493d0$var$_index5.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $77ac9d4f3f6493d0$var$_index6.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $77ac9d4f3f6493d0$var$_index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $77ac9d4f3f6493d0$var$_index3.default)(date);
        // Padding
        return (0, $77ac9d4f3f6493d0$var$_index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $77ac9d4f3f6493d0$var$_index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $77ac9d4f3f6493d0$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $77ac9d4f3f6493d0$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $77ac9d4f3f6493d0$var$_index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $77ac9d4f3f6493d0$var$_index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $77ac9d4f3f6493d0$var$_index4.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $77ac9d4f3f6493d0$var$_index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $77ac9d4f3f6493d0$var$_index2.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $77ac9d4f3f6493d0$var$_index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $77ac9d4f3f6493d0$var$_index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $77ac9d4f3f6493d0$var$_index.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $77ac9d4f3f6493d0$var$_index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $77ac9d4f3f6493d0$var$_index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $77ac9d4f3f6493d0$var$_index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $77ac9d4f3f6493d0$var$_index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $77ac9d4f3f6493d0$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $77ac9d4f3f6493d0$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $77ac9d4f3f6493d0$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $77ac9d4f3f6493d0$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $77ac9d4f3f6493d0$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $77ac9d4f3f6493d0$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $77ac9d4f3f6493d0$var$_index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $77ac9d4f3f6493d0$var$_index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $77ac9d4f3f6493d0$var$_index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $77ac9d4f3f6493d0$var$_index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $77ac9d4f3f6493d0$var$_index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $77ac9d4f3f6493d0$var$_index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return $77ac9d4f3f6493d0$var$_index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $77ac9d4f3f6493d0$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $77ac9d4f3f6493d0$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $77ac9d4f3f6493d0$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $77ac9d4f3f6493d0$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $77ac9d4f3f6493d0$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $77ac9d4f3f6493d0$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $77ac9d4f3f6493d0$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $77ac9d4f3f6493d0$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $77ac9d4f3f6493d0$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $77ac9d4f3f6493d0$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $77ac9d4f3f6493d0$var$_index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $77ac9d4f3f6493d0$var$_index6.default)(timestamp, token.length);
    }
};
function $77ac9d4f3f6493d0$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $77ac9d4f3f6493d0$var$_index6.default)(minutes, 2);
}
function $77ac9d4f3f6493d0$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $77ac9d4f3f6493d0$var$_index6.default)(Math.abs(offset) / 60, 2);
    }
    return $77ac9d4f3f6493d0$var$formatTimezone(offset, dirtyDelimiter);
}
function $77ac9d4f3f6493d0$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $77ac9d4f3f6493d0$var$_index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $77ac9d4f3f6493d0$var$_index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $77ac9d4f3f6493d0$var$_default = $77ac9d4f3f6493d0$var$formatters;
module.exports.default = $77ac9d4f3f6493d0$var$_default;
module.exports = module.exports.default;

});

parcelRegister("bPmt4", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $89c5e2c8978bfd42$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89c5e2c8978bfd42$var$getUTCDayOfYear;

var $89c5e2c8978bfd42$var$_index = $89c5e2c8978bfd42$require$_interopRequireDefault((parcelRequire("g8Sb7")));

var $89c5e2c8978bfd42$var$_index2 = $89c5e2c8978bfd42$require$_interopRequireDefault((parcelRequire("4UaOz")));
var $89c5e2c8978bfd42$var$MILLISECONDS_IN_DAY = 86400000;
function $89c5e2c8978bfd42$var$getUTCDayOfYear(dirtyDate) {
    (0, $89c5e2c8978bfd42$var$_index2.default)(1, arguments);
    var date = (0, $89c5e2c8978bfd42$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $89c5e2c8978bfd42$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("lz2TJ", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $fb2f1d4edfc4f8fb$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb2f1d4edfc4f8fb$var$getUTCISOWeek;

var $fb2f1d4edfc4f8fb$var$_index = $fb2f1d4edfc4f8fb$require$_interopRequireDefault((parcelRequire("g8Sb7")));

var $fb2f1d4edfc4f8fb$var$_index2 = $fb2f1d4edfc4f8fb$require$_interopRequireDefault((parcelRequire("5fWkN")));

var $fb2f1d4edfc4f8fb$var$_index3 = $fb2f1d4edfc4f8fb$require$_interopRequireDefault((parcelRequire("bi4Qf")));

var $fb2f1d4edfc4f8fb$var$_index4 = $fb2f1d4edfc4f8fb$require$_interopRequireDefault((parcelRequire("4UaOz")));
var $fb2f1d4edfc4f8fb$var$MILLISECONDS_IN_WEEK = 604800000;
function $fb2f1d4edfc4f8fb$var$getUTCISOWeek(dirtyDate) {
    (0, $fb2f1d4edfc4f8fb$var$_index4.default)(1, arguments);
    var date = (0, $fb2f1d4edfc4f8fb$var$_index.default)(dirtyDate);
    var diff = (0, $fb2f1d4edfc4f8fb$var$_index2.default)(date).getTime() - (0, $fb2f1d4edfc4f8fb$var$_index3.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $fb2f1d4edfc4f8fb$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("5fWkN", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $3d3b9a79e93bd477$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d3b9a79e93bd477$var$startOfUTCISOWeek;

var $3d3b9a79e93bd477$var$_index = $3d3b9a79e93bd477$require$_interopRequireDefault((parcelRequire("g8Sb7")));

var $3d3b9a79e93bd477$var$_index2 = $3d3b9a79e93bd477$require$_interopRequireDefault((parcelRequire("4UaOz")));
function $3d3b9a79e93bd477$var$startOfUTCISOWeek(dirtyDate) {
    (0, $3d3b9a79e93bd477$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $3d3b9a79e93bd477$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("bi4Qf", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $83852197abd6e6b8$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $83852197abd6e6b8$var$startOfUTCISOWeekYear;

var $83852197abd6e6b8$var$_index = $83852197abd6e6b8$require$_interopRequireDefault((parcelRequire("hyGqb")));

var $83852197abd6e6b8$var$_index2 = $83852197abd6e6b8$require$_interopRequireDefault((parcelRequire("5fWkN")));

var $83852197abd6e6b8$var$_index3 = $83852197abd6e6b8$require$_interopRequireDefault((parcelRequire("4UaOz")));
function $83852197abd6e6b8$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $83852197abd6e6b8$var$_index3.default)(1, arguments);
    var year = (0, $83852197abd6e6b8$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $83852197abd6e6b8$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("hyGqb", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $cc8684a53d19f8aa$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc8684a53d19f8aa$var$getUTCISOWeekYear;

var $cc8684a53d19f8aa$var$_index = $cc8684a53d19f8aa$require$_interopRequireDefault((parcelRequire("g8Sb7")));

var $cc8684a53d19f8aa$var$_index2 = $cc8684a53d19f8aa$require$_interopRequireDefault((parcelRequire("4UaOz")));

var $cc8684a53d19f8aa$var$_index3 = $cc8684a53d19f8aa$require$_interopRequireDefault((parcelRequire("5fWkN")));
function $cc8684a53d19f8aa$var$getUTCISOWeekYear(dirtyDate) {
    (0, $cc8684a53d19f8aa$var$_index2.default)(1, arguments);
    var date = (0, $cc8684a53d19f8aa$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $cc8684a53d19f8aa$var$_index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $cc8684a53d19f8aa$var$_index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});

parcelRegister("4ovpr", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $3331c48ad02a0c83$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3331c48ad02a0c83$var$getUTCWeek;

var $3331c48ad02a0c83$var$_index = $3331c48ad02a0c83$require$_interopRequireDefault((parcelRequire("g8Sb7")));

var $3331c48ad02a0c83$var$_index2 = $3331c48ad02a0c83$require$_interopRequireDefault((parcelRequire("lFAOq")));

var $3331c48ad02a0c83$var$_index3 = $3331c48ad02a0c83$require$_interopRequireDefault((parcelRequire("6UPUR")));

var $3331c48ad02a0c83$var$_index4 = $3331c48ad02a0c83$require$_interopRequireDefault((parcelRequire("4UaOz")));
var $3331c48ad02a0c83$var$MILLISECONDS_IN_WEEK = 604800000;
function $3331c48ad02a0c83$var$getUTCWeek(dirtyDate, options) {
    (0, $3331c48ad02a0c83$var$_index4.default)(1, arguments);
    var date = (0, $3331c48ad02a0c83$var$_index.default)(dirtyDate);
    var diff = (0, $3331c48ad02a0c83$var$_index2.default)(date, options).getTime() - (0, $3331c48ad02a0c83$var$_index3.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $3331c48ad02a0c83$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("lFAOq", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $fc69fb728271ae43$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fc69fb728271ae43$var$startOfUTCWeek;

var $fc69fb728271ae43$var$_index = $fc69fb728271ae43$require$_interopRequireDefault((parcelRequire("g8Sb7")));

var $fc69fb728271ae43$var$_index2 = $fc69fb728271ae43$require$_interopRequireDefault((parcelRequire("4UaOz")));

var $fc69fb728271ae43$var$_index3 = $fc69fb728271ae43$require$_interopRequireDefault((parcelRequire("9Ip6t")));

var $72yv4 = parcelRequire("72yv4");

function $fc69fb728271ae43$var$startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $fc69fb728271ae43$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $72yv4.getDefaultOptions)();
    var weekStartsOn = (0, $fc69fb728271ae43$var$_index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $fc69fb728271ae43$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("6UPUR", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $50903e7b61169d45$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $50903e7b61169d45$var$startOfUTCWeekYear;

var $50903e7b61169d45$var$_index = $50903e7b61169d45$require$_interopRequireDefault((parcelRequire("cgYRX")));

var $50903e7b61169d45$var$_index2 = $50903e7b61169d45$require$_interopRequireDefault((parcelRequire("4UaOz")));

var $50903e7b61169d45$var$_index3 = $50903e7b61169d45$require$_interopRequireDefault((parcelRequire("lFAOq")));

var $50903e7b61169d45$var$_index4 = $50903e7b61169d45$require$_interopRequireDefault((parcelRequire("9Ip6t")));

var $72yv4 = parcelRequire("72yv4");

function $50903e7b61169d45$var$startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $50903e7b61169d45$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $72yv4.getDefaultOptions)();
    var firstWeekContainsDate = (0, $50903e7b61169d45$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $50903e7b61169d45$var$_index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $50903e7b61169d45$var$_index3.default)(firstWeek, options);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("cgYRX", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $8ef632081adfd74d$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8ef632081adfd74d$var$getUTCWeekYear;

var $8ef632081adfd74d$var$_index = $8ef632081adfd74d$require$_interopRequireDefault((parcelRequire("g8Sb7")));

var $8ef632081adfd74d$var$_index2 = $8ef632081adfd74d$require$_interopRequireDefault((parcelRequire("4UaOz")));

var $8ef632081adfd74d$var$_index3 = $8ef632081adfd74d$require$_interopRequireDefault((parcelRequire("lFAOq")));

var $8ef632081adfd74d$var$_index4 = $8ef632081adfd74d$require$_interopRequireDefault((parcelRequire("9Ip6t")));

var $72yv4 = parcelRequire("72yv4");

function $8ef632081adfd74d$var$getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $8ef632081adfd74d$var$_index2.default)(1, arguments);
    var date = (0, $8ef632081adfd74d$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $72yv4.getDefaultOptions)();
    var firstWeekContainsDate = (0, $8ef632081adfd74d$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8ef632081adfd74d$var$_index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8ef632081adfd74d$var$_index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});

parcelRegister("37kDQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $245209877258300e$var$addLeadingZeros;
function $245209877258300e$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});

parcelRegister("jlCLJ", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $e15e0d2d1ddd3bc8$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e15e0d2d1ddd3bc8$var$_index = $e15e0d2d1ddd3bc8$require$_interopRequireDefault((parcelRequire("37kDQ")));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $e15e0d2d1ddd3bc8$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $e15e0d2d1ddd3bc8$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $e15e0d2d1ddd3bc8$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $e15e0d2d1ddd3bc8$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $e15e0d2d1ddd3bc8$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $e15e0d2d1ddd3bc8$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $e15e0d2d1ddd3bc8$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $e15e0d2d1ddd3bc8$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $e15e0d2d1ddd3bc8$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $e15e0d2d1ddd3bc8$var$_default = $e15e0d2d1ddd3bc8$var$formatters;
module.exports.default = $e15e0d2d1ddd3bc8$var$_default;
module.exports = module.exports.default;

});

parcelRegister("k1iYS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e9329fdef5297ddf$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $e9329fdef5297ddf$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $e9329fdef5297ddf$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $e9329fdef5297ddf$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $e9329fdef5297ddf$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $e9329fdef5297ddf$var$timeLongFormatter(timePattern, formatLong));
};
var $e9329fdef5297ddf$var$longFormatters = {
    p: $e9329fdef5297ddf$var$timeLongFormatter,
    P: $e9329fdef5297ddf$var$dateTimeLongFormatter
};
var $e9329fdef5297ddf$var$_default = $e9329fdef5297ddf$var$longFormatters;
module.exports.default = $e9329fdef5297ddf$var$_default;
module.exports = module.exports.default;

});

parcelRegister("dsDXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ccce2f97a778d14$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $9ccce2f97a778d14$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("lfpjG", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $f77ea2fe391055f6$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f77ea2fe391055f6$var$_index = $f77ea2fe391055f6$require$_interopRequireDefault((parcelRequire("cGEW9")));
var $f77ea2fe391055f6$var$_default = $f77ea2fe391055f6$var$_index.default;
module.exports.default = $f77ea2fe391055f6$var$_default;
module.exports = module.exports.default;

});

parcelRegister("cGEW9", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $93c929861e0637dd$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93c929861e0637dd$var$_index = $93c929861e0637dd$require$_interopRequireDefault((parcelRequire("e6Kg5")));

var $93c929861e0637dd$var$_index2 = $93c929861e0637dd$require$_interopRequireDefault((parcelRequire("eDzCD")));

var $93c929861e0637dd$var$_index3 = $93c929861e0637dd$require$_interopRequireDefault((parcelRequire("2sud6")));

var $93c929861e0637dd$var$_index4 = $93c929861e0637dd$require$_interopRequireDefault((parcelRequire("bYEmB")));

var $93c929861e0637dd$var$_index5 = $93c929861e0637dd$require$_interopRequireDefault((parcelRequire("1jQjT")));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $93c929861e0637dd$var$locale = {
    code: 'en-US',
    formatDistance: $93c929861e0637dd$var$_index.default,
    formatLong: $93c929861e0637dd$var$_index2.default,
    formatRelative: $93c929861e0637dd$var$_index3.default,
    localize: $93c929861e0637dd$var$_index4.default,
    match: $93c929861e0637dd$var$_index5.default,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $93c929861e0637dd$var$_default = $93c929861e0637dd$var$locale;
module.exports.default = $93c929861e0637dd$var$_default;
module.exports = module.exports.default;

});

parcelRegister("e6Kg5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a455822fe243a80a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $a455822fe243a80a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a455822fe243a80a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $a455822fe243a80a$var$_default = $a455822fe243a80a$var$formatDistance;
module.exports.default = $a455822fe243a80a$var$_default;
module.exports = module.exports.default;

});

parcelRegister("eDzCD", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $aa805706822c29e6$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa805706822c29e6$var$_index = $aa805706822c29e6$require$_interopRequireDefault((parcelRequire("fhPZb")));
var $aa805706822c29e6$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $aa805706822c29e6$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $aa805706822c29e6$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $aa805706822c29e6$var$formatLong = {
    date: (0, $aa805706822c29e6$var$_index.default)({
        formats: $aa805706822c29e6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $aa805706822c29e6$var$_index.default)({
        formats: $aa805706822c29e6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $aa805706822c29e6$var$_index.default)({
        formats: $aa805706822c29e6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $aa805706822c29e6$var$_default = $aa805706822c29e6$var$formatLong;
module.exports.default = $aa805706822c29e6$var$_default;
module.exports = module.exports.default;

});

parcelRegister("fhPZb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b210c4db3969e18a$var$buildFormatLongFn;
function $b210c4db3969e18a$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});

parcelRegister("2sud6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $1ca5a17111e830e3$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $1ca5a17111e830e3$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $1ca5a17111e830e3$var$formatRelativeLocale[token];
};
var $1ca5a17111e830e3$var$_default = $1ca5a17111e830e3$var$formatRelative;
module.exports.default = $1ca5a17111e830e3$var$_default;
module.exports = module.exports.default;

});

parcelRegister("bYEmB", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $8b849bb02a699b3c$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b849bb02a699b3c$var$_index = $8b849bb02a699b3c$require$_interopRequireDefault((parcelRequire("cji6d")));
var $8b849bb02a699b3c$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $8b849bb02a699b3c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $8b849bb02a699b3c$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $8b849bb02a699b3c$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $8b849bb02a699b3c$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $8b849bb02a699b3c$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $8b849bb02a699b3c$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $8b849bb02a699b3c$var$localize = {
    ordinalNumber: $8b849bb02a699b3c$var$ordinalNumber,
    era: (0, $8b849bb02a699b3c$var$_index.default)({
        values: $8b849bb02a699b3c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $8b849bb02a699b3c$var$_index.default)({
        values: $8b849bb02a699b3c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $8b849bb02a699b3c$var$_index.default)({
        values: $8b849bb02a699b3c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $8b849bb02a699b3c$var$_index.default)({
        values: $8b849bb02a699b3c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $8b849bb02a699b3c$var$_index.default)({
        values: $8b849bb02a699b3c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8b849bb02a699b3c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8b849bb02a699b3c$var$_default = $8b849bb02a699b3c$var$localize;
module.exports.default = $8b849bb02a699b3c$var$_default;
module.exports = module.exports.default;

});

parcelRegister("cji6d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f654c855f4653a0$var$buildLocalizeFn;
function $8f654c855f4653a0$var$buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});

parcelRegister("1jQjT", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $0f60266b53f92385$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f60266b53f92385$var$_index = $0f60266b53f92385$require$_interopRequireDefault((parcelRequire("ed2mW")));

var $0f60266b53f92385$var$_index2 = $0f60266b53f92385$require$_interopRequireDefault((parcelRequire("d4Byk")));
var $0f60266b53f92385$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $0f60266b53f92385$var$parseOrdinalNumberPattern = /\d+/i;
var $0f60266b53f92385$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $0f60266b53f92385$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $0f60266b53f92385$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $0f60266b53f92385$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0f60266b53f92385$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $0f60266b53f92385$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $0f60266b53f92385$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $0f60266b53f92385$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $0f60266b53f92385$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $0f60266b53f92385$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $0f60266b53f92385$var$match = {
    ordinalNumber: (0, $0f60266b53f92385$var$_index2.default)({
        matchPattern: $0f60266b53f92385$var$matchOrdinalNumberPattern,
        parsePattern: $0f60266b53f92385$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $0f60266b53f92385$var$_index.default)({
        matchPatterns: $0f60266b53f92385$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f60266b53f92385$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $0f60266b53f92385$var$_index.default)({
        matchPatterns: $0f60266b53f92385$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f60266b53f92385$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $0f60266b53f92385$var$_index.default)({
        matchPatterns: $0f60266b53f92385$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f60266b53f92385$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $0f60266b53f92385$var$_index.default)({
        matchPatterns: $0f60266b53f92385$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f60266b53f92385$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $0f60266b53f92385$var$_index.default)({
        matchPatterns: $0f60266b53f92385$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0f60266b53f92385$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0f60266b53f92385$var$_default = $0f60266b53f92385$var$match;
module.exports.default = $0f60266b53f92385$var$_default;
module.exports = module.exports.default;

});

parcelRegister("ed2mW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a5841e0cba749279$var$buildMatchFn;
function $a5841e0cba749279$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $a5841e0cba749279$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $a5841e0cba749279$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $a5841e0cba749279$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $a5841e0cba749279$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});

parcelRegister("d4Byk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9848c74317315292$var$buildMatchPatternFn;
function $9848c74317315292$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("72P30", function(module, exports) {
$parcel$export(module.exports, "default", () => $52105145f71af714$export$2e2bcd8739ae039);

var $e99z3 = parcelRequire("e99z3");


var $lj2T2 = parcelRequire("lj2T2");


var $jcUTC = parcelRequire("jcUTC");

function $52105145f71af714$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($e99z3)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $lj2T2.default)((0, $jcUTC.default)(date, timeZone), formatStr, extendedOptions);
}

});

parcelRegister("e99z3", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

var $a4c953438ae8f82f$require$_interopRequireDefault = $eGvGZ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4c953438ae8f82f$var$cloneObject;

var $a4c953438ae8f82f$var$_index = $a4c953438ae8f82f$require$_interopRequireDefault((parcelRequire("gBYMY")));
function $a4c953438ae8f82f$var$cloneObject(object) {
    return (0, $a4c953438ae8f82f$var$_index.default)({}, object);
}
module.exports = module.exports.default;

});

parcelRegister("gBYMY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c17f4172297345c2$var$assign;
function $c17f4172297345c2$var$assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = module.exports.default;

});

parcelRegister("fHxn4", function(module, exports) {

var $dedJV = parcelRequire("dedJV");

var $lzcvT = parcelRequire("lzcvT");


var $dh538 = parcelRequire("dh538");


var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");


var $kmvqe = parcelRequire("kmvqe");


var $kCJlM = parcelRequire("kCJlM");


var $aVH97 = parcelRequire("aVH97");

const $a7f2279fbf11205d$var$buildActivationIdQuery = (cloudId, product)=>({
        query: `
		query RovoAgentProfileCard_ActivationQuery($cloudId: ID!, $product: String!) {
			tenantContexts(cloudIds: [$cloudId]) {
				activationIdByProduct(product: $product) {
					active
				}
			}
		}
	`,
        variables: {
            cloudId: cloudId,
            product: product
        }
    });
const $a7f2279fbf11205d$var$buildRovoAgentQueryByAri = (agentAri)=>({
        query: `
	  query RovoAgentProfileCard_AgentQueryByAri($agentAri: ID!) {
			agentStudio_agentById(id: $agentAri) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            agentAri: agentAri
        }
    });
const $a7f2279fbf11205d$var$buildRovoAgentQueryByAccountId = (identityAccountId, cloudId)=>({
        query: `
		query RovoAgentProfileCard_AgentQueryByAccountId($identityAccountId: ID!, $cloudId: ID!) {
			agentStudio_agentByIdentityAccountId(identityAccountId: $identityAccountId, cloudId: $cloudId) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
						profileUrl
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            identityAccountId: identityAccountId,
            cloudId: cloudId
        }
    });
const $a7f2279fbf11205d$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $a7f2279fbf11205d$export$2e2bcd8739ae039 extends (0, $kmvqe.default) {
    basePath() {
        return (0, $dh538.fg)('pt-deprecate-assistance-service') ? '/gateway/api/assist/rovo/v1/agents' : '/gateway/api/assist/agents/v1';
    }
    async getActivationId(cloudId, product) {
        const response = await (0, $aVH97.AGGQuery)('/gateway/api/graphql', $a7f2279fbf11205d$var$buildActivationIdQuery(cloudId, product));
        return response?.tenantContexts?.[0]?.activationIdByProduct?.active ?? null;
    }
    async getAgentByARIAgg(agentAri) {
        const response = await (0, $aVH97.AGGQuery)('/gateway/api/graphql', $a7f2279fbf11205d$var$buildRovoAgentQueryByAri(agentAri));
        if (response.agentStudio_agentById?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentById returning QueryError: ${response.agentStudio_agentById.message}`);
        return response?.agentStudio_agentById;
    }
    async getAgentByAccountIdAgg(identityAccountId, cloudId) {
        const response = await (0, $aVH97.AGGQuery)('/gateway/api/graphql', $a7f2279fbf11205d$var$buildRovoAgentQueryByAccountId(identityAccountId, cloudId));
        if (response.agentStudio_agentByIdentityAccountId?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentByIdentityAccountId returning QueryError: ${response.agentStudio_agentByIdentityAccountId.message}`);
        return response?.agentStudio_agentByIdentityAccountId;
    }
    makeRequest(id, analytics) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $a7f2279fbf11205d$var$createHeaders(product, this.options.cloudId);
        let restPromise;
        if (id.type === 'identity') restPromise = fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        else restPromise = fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        const aggStartTime = (0, $caPHA.getPageTime)();
        const aggPromise = this.getActivationId(this.options.cloudId || '', this.options.productIdentifier || 'rovo').then((activationId)=>{
            if (!activationId) throw new Error('ProfileCard Activation ID not found');
            if (id.type === 'identity') return this.getAgentByAccountIdAgg(id.value, this.options.cloudId || '');
            else {
                const agentAri = `ari:cloud:rovo::agent/activation/${activationId}/${id.value}`;
                return this.getAgentByARIAgg(agentAri);
            }
        })// We are not going to break the flow if the AGG endpoint fails for now
        // @TODO once all the data moved to AGG, we can remove this catch
        .catch((error)=>{
            if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                ...(0, $kCJlM.getErrorAttributes)(error),
                errorType: 'RovoAgentProfileCardAggError',
                duration: (0, $caPHA.getPageTime)() - aggStartTime,
                gateway: true,
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            return Promise.resolve(null);
        });
        return Promise.all([
            restPromise,
            aggPromise
        ]).then(([restData, aggData])=>({
                restData: restData,
                aggData: aggData
            }));
    }
    /**
   * This function will call both REST and AGG endpoints to get the agent profile
   * There are some data that is only available in the AGG endpoint, so we need to call both
   * For any new fields, please only add them to the AGG endpoint
   *
   * @TODO migrate everything to AGG endpoint
   */ getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $caPHA.getPageTime)();
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            this.makeRequest(id, analytics).then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.request', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    ...(0, $kCJlM.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $caPHA.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            const headers = $a7f2279fbf11205d$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.deleteAgent', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                resolve();
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.deleteAgent', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    ...(0, $kCJlM.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $caPHA.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics(`operational.rovoAgentProfilecard.triggered.${actionSubjectId}`, {
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            const headers = $a7f2279fbf11205d$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.succeeded.${actionSubjectId}`, {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                resolve();
            }).catch((error)=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.failed.${actionSubjectId}`, {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    ...(0, $kCJlM.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $caPHA.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            const headers = $a7f2279fbf11205d$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.succeeded.getAgentPermissions', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.failed.getAgentPermissions', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    ...(0, $kCJlM.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    constructor(options){
        super(options);
        this.options = void 0;
        this.options = options;
    }
}











const $6ce2559670a7bfd5$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $6ce2559670a7bfd5$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $6ce2559670a7bfd5$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $6ce2559670a7bfd5$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $aVH97.AGGQuery)(url, query, $6ce2559670a7bfd5$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}





const $48e387840da64dcc$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $48e387840da64dcc$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $48e387840da64dcc$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $48e387840da64dcc$var$orgIdPromiseCache = new Map();
const $48e387840da64dcc$var$workspaceExistsWithTypePromiseCache = new Map();
class $48e387840da64dcc$var$TeamCentralCardClient extends (0, $kmvqe.default) {
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $48e387840da64dcc$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $48e387840da64dcc$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
             * Reporting lines aren't part of the critical path of profile card.
             * Just resolve with empty values instead of bubbling up the error.
             */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
   * `public` so that mock client can override it; do not use it otherwise!
   */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $48e387840da64dcc$export$1862ef0c3880ca8d(userId);
        const response = await (0, $aVH97.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $dh538.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $48e387840da64dcc$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $48e387840da64dcc$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $dh538.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $48e387840da64dcc$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return workspaceType;
            }
            return undefined;
        } catch (err) {
            return undefined;
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $48e387840da64dcc$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $6ce2559670a7bfd5$export$d38a536fd806c68f)(gatewayGraphqlUrl, cloudId);
        $48e387840da64dcc$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
    constructor(options){
        super(options);
        this.options = void 0;
        /**
     * Simple circuit breaker to avoid making unnecessary calls to Team Central on auth failures
     * This is to handle the case where products may have provided teamCentralUrl, but the site itself
     * doesn't actually have any TC product.
     *
     * There's currently no way to reset this circuit breaker, but that's fine. This is meant to
     * catch a pretty specific edge case.
     */ this.bypassOnFailure = void 0;
        this.orgContainsAnyWorkspacePromise = void 0;
        this.orgIdPromise = void 0;
        this.workspaceExistsWithTypePromise = void 0;
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
}
var $48e387840da64dcc$export$2e2bcd8739ae039 = $48e387840da64dcc$var$TeamCentralCardClient;



var $78rLF = parcelRequire("78rLF");


var $8zKPT = parcelRequire("8zKPT");

const $b78e5b2d0d989bcd$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $b78e5b2d0d989bcd$var$ProfileCardClient {
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $dedJV.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $dedJV.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
    constructor(config, clients){
        this.userClient = void 0;
        this.teamClient = void 0;
        this.tcClient = void 0;
        this.rovoAgentClient = void 0;
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$b78e5b2d0d989bcd$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $b78e5b2d0d989bcd$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $8zKPT.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $78rLF.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $a7f2279fbf11205d$export$2e2bcd8739ae039)(withDefaultConfig);
        this.tcClient = $b78e5b2d0d989bcd$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
}
function $b78e5b2d0d989bcd$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $lzcvT.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $48e387840da64dcc$export$2e2bcd8739ae039)({
        ...config
    }) : undefined;
}
var $b78e5b2d0d989bcd$export$2e2bcd8739ae039 = $b78e5b2d0d989bcd$var$ProfileCardClient;
module.exports["default"] = $b78e5b2d0d989bcd$export$2e2bcd8739ae039;

});

parcelRegister("fZXex", function(module, exports) {
/// <reference types="node" />
// for typing `process`

var $aVH97 = parcelRequire("aVH97");

const $1b66b6deb1213fbb$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $1b66b6deb1213fbb$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $1b66b6deb1213fbb$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $1b66b6deb1213fbb$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($1b66b6deb1213fbb$var$ARI_PREFIX) ? teamIdOrTeamAri : $1b66b6deb1213fbb$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $1b66b6deb1213fbb$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $1b66b6deb1213fbb$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $1b66b6deb1213fbb$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
	  state
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $1b66b6deb1213fbb$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$1b66b6deb1213fbb$var$TEAM_FRAGMENT}
    }
  }
}`;
const $1b66b6deb1213fbb$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $1b66b6deb1213fbb$export$4968f4e0119a5d9c,
        variables: {
            teamId: $1b66b6deb1213fbb$export$7878e28c136af76(teamId),
            siteId: siteId || 'None'
        }
    });
const $1b66b6deb1213fbb$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $1b66b6deb1213fbb$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $1b66b6deb1213fbb$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $aVH97.AGGQuery)(url, query, $1b66b6deb1213fbb$export$1229c72526c01df2);
    return $1b66b6deb1213fbb$export$fce1abb40bf8db94(Team);
}
module.exports["extractIdFromAri"] = $1b66b6deb1213fbb$export$5816a09dbb711691;
module.exports["getTeamFromAGG"] = $1b66b6deb1213fbb$export$26a8aad0c7182dd6;

});

parcelRegister("8zKPT", function(module, exports) {

var $lB1H3 = parcelRequire("lB1H3");


var $eSUdr = parcelRequire("eSUdr");


var $dh538 = parcelRequire("dh538");


var $bUp2E = parcelRequire("bUp2E");

parcelRequire("3Vbz9");
var $72P30 = parcelRequire("72P30");

const $7dfb6f1da66202e8$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $72P30.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};



var $caPHA = parcelRequire("caPHA");


var $kmvqe = parcelRequire("kmvqe");


var $kCJlM = parcelRequire("kCJlM");


var $aVH97 = parcelRequire("aVH97");

const $dda4685cc624023e$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $dda4685cc624023e$var$aggUserQuery = (0, $eSUdr.default)`query user($userId:ID!){user(accountId:$userId){id name picture accountStatus __typename ...on AtlassianAccountUser{email nickname zoneinfo extendedProfile{jobTitle organization location closedDate inactiveDate}}...on CustomerUser{email zoneinfo}...on AppUser{appType}}}`;
const $dda4685cc624023e$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $dda4685cc624023e$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $dh538.fg)('platform_agg_user_query_doc_change') ? (0, $lB1H3.print)($dda4685cc624023e$var$aggUserQuery) : $dda4685cc624023e$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $dda4685cc624023e$var$queryAGGUser = async (url, userId)=>{
    const query = $dda4685cc624023e$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $aVH97.AGGQuery)(url, query);
    return user;
};
class $dda4685cc624023e$export$2e2bcd8739ae039 extends (0, $kmvqe.default) {
    async makeRequest(_cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $dda4685cc624023e$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        const timeFormat = 'h:mmaaa';
        if (user.zoneinfo) {
            if ((0, $7dfb6f1da66202e8$export$f0dfd716e7b023cd)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $7dfb6f1da66202e8$export$f0dfd716e7b023cd)(user.zoneinfo, timeFormat) || undefined;
            else timestring = (0, $7dfb6f1da66202e8$export$f0dfd716e7b023cd)(user.zoneinfo, `eee ${timeFormat}`) || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            isServiceAccount: user.__typename === 'AppUser' && user.appType === 'service',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $caPHA.getPageTime)();
            if (analytics) analytics('operational.profilecard.triggered.request', {
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics('operational.profilecard.succeeded.request', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics('operational.profilecard.failed.request', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    ...(0, $kCJlM.getErrorAttributes)(error),
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    constructor(options){
        super(options);
        this.options = void 0;
        this.options = options;
    }
}
module.exports["default"] = $dda4685cc624023e$export$2e2bcd8739ae039;

});

parcelRegister("7c52C", function(module, exports) {
$parcel$export(module.exports, "default", () => $94258644e6a54f77$export$2e2bcd8739ae039);


var $fHxn4 = parcelRequire("fHxn4");



var $8zKPT = parcelRequire("8zKPT");

var $94258644e6a54f77$export$2e2bcd8739ae039 = (0, $fHxn4.default);

});

parcelRegister("5XsiK", function(module, exports) {
$parcel$export(module.exports, "isTeamsAppEnabled", () => (parcelRequire("lfSOe")).isTeamsAppEnabled);

var $lfSOe = parcelRequire("lfSOe");


});

parcelRegister("bYUc2", function(module, exports) {

var $1dnxO = parcelRequire("1dnxO");

const $e2bf374f654691d1$export$bd6b49f42ca8817b = ()=>{
    try {
        return (0, $1dnxO.getIsNav4Enabled)();
    } catch  {
        return false;
    }
};
module.exports["getIsNav4EnabledSafe"] = $e2bf374f654691d1$export$bd6b49f42ca8817b;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("lj2T2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f82d9c8bd4a9adcb$export$2e2bcd8739ae039);

var $1xmby = parcelRequire("1xmby");

/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $995f32270bd696e0$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $995f32270bd696e0$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $995f32270bd696e0$var$partsTimeZone(dtf, date) : $995f32270bd696e0$var$hackyTimeZone(dtf, date);
}
function $995f32270bd696e0$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $995f32270bd696e0$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $995f32270bd696e0$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}



var $kHG3y = parcelRequire("kHG3y");

var $a4811d9a425835ea$var$MILLISECONDS_IN_MINUTE = 60000;
var $a4811d9a425835ea$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $a4811d9a425835ea$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $a4811d9a425835ea$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $a4811d9a425835ea$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $a4811d9a425835ea$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $a4811d9a425835ea$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $a4811d9a425835ea$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $a4811d9a425835ea$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $a4811d9a425835ea$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $a4811d9a425835ea$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $a4811d9a425835ea$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $a4811d9a425835ea$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $995f32270bd696e0$export$2e2bcd8739ae039)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $995f32270bd696e0$export$2e2bcd8739ae039)('long', date, options);
        }
    }
};
function $a4811d9a425835ea$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $kHG3y.default)(timeZone, originalDate, true) / $a4811d9a425835ea$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $a4811d9a425835ea$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $a4811d9a425835ea$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $a4811d9a425835ea$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $a4811d9a425835ea$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $a4811d9a425835ea$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $a4811d9a425835ea$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $a4811d9a425835ea$var$formatTimezone(offset, dirtyDelimeter);
}
function $a4811d9a425835ea$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $a4811d9a425835ea$var$addLeadingZeros(minutes, 2);
}
var $a4811d9a425835ea$export$2e2bcd8739ae039 = $a4811d9a425835ea$var$formatters;



var $a7WsF = parcelRequire("a7WsF");

var $f82d9c8bd4a9adcb$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $f82d9c8bd4a9adcb$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($f82d9c8bd4a9adcb$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $a7WsF.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $a4811d9a425835ea$export$2e2bcd8739ae039)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($1xmby)))(dirtyDate, formatStr, options);
}

});

parcelRegister("arf52", function(module, exports) {
$parcel$export(module.exports, "default", () => $79981f9fed83c367$export$2e2bcd8739ae039);

var $kHG3y = parcelRequire("kHG3y");

function $79981f9fed83c367$export$2e2bcd8739ae039(timeZone, date) {
    return -(0, $kHG3y.default)(timeZone, date);
}

});

parcelRegister("a7WsF", function(module, exports) {
$parcel$export(module.exports, "default", () => $75f7e80fb882929b$export$2e2bcd8739ae039);

var $9Ip6t = parcelRequire("9Ip6t");


var $dsDXx = parcelRequire("dsDXx");


var $kHG3y = parcelRequire("kHG3y");

/** Regex to identify the presence of a time zone specifier in a date string */ var $dbbbc43e21091b09$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $dbbbc43e21091b09$export$2e2bcd8739ae039 = $dbbbc43e21091b09$var$tzPattern;


var $75f7e80fb882929b$var$MILLISECONDS_IN_HOUR = 3600000;
var $75f7e80fb882929b$var$MILLISECONDS_IN_MINUTE = 60000;
var $75f7e80fb882929b$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $75f7e80fb882929b$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $dbbbc43e21091b09$export$2e2bcd8739ae039)
};
function $75f7e80fb882929b$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $75f7e80fb882929b$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($9Ip6t)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $75f7e80fb882929b$var$splitDateString(argument);
    var parseYearResult = $75f7e80fb882929b$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $75f7e80fb882929b$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $75f7e80fb882929b$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $kHG3y.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($dsDXx)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($dsDXx)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $75f7e80fb882929b$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $75f7e80fb882929b$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $75f7e80fb882929b$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $75f7e80fb882929b$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $75f7e80fb882929b$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $75f7e80fb882929b$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $75f7e80fb882929b$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $75f7e80fb882929b$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $75f7e80fb882929b$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $75f7e80fb882929b$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $75f7e80fb882929b$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$75f7e80fb882929b$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $75f7e80fb882929b$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$75f7e80fb882929b$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $75f7e80fb882929b$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$75f7e80fb882929b$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $75f7e80fb882929b$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$75f7e80fb882929b$var$validateWeekDate(year, week)) return new Date(NaN);
        return $75f7e80fb882929b$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $75f7e80fb882929b$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$75f7e80fb882929b$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $75f7e80fb882929b$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $75f7e80fb882929b$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $75f7e80fb882929b$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$75f7e80fb882929b$var$validateTime(hours)) return NaN;
        return hours % 24 * $75f7e80fb882929b$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $75f7e80fb882929b$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$75f7e80fb882929b$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $75f7e80fb882929b$var$MILLISECONDS_IN_HOUR + minutes * $75f7e80fb882929b$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $75f7e80fb882929b$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$75f7e80fb882929b$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $75f7e80fb882929b$var$MILLISECONDS_IN_HOUR + minutes * $75f7e80fb882929b$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $75f7e80fb882929b$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $75f7e80fb882929b$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $75f7e80fb882929b$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $75f7e80fb882929b$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $75f7e80fb882929b$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $75f7e80fb882929b$var$isLeapYearIndex(year);
        if (isLeapYear && date > $75f7e80fb882929b$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $75f7e80fb882929b$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $75f7e80fb882929b$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $75f7e80fb882929b$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $75f7e80fb882929b$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $75f7e80fb882929b$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});

parcelRegister("jcUTC", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfbb45b3ee7e50f5$export$2e2bcd8739ae039);

var $kHG3y = parcelRequire("kHG3y");


var $a7WsF = parcelRequire("a7WsF");

function $dfbb45b3ee7e50f5$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $a7WsF.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $kHG3y.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});

parcelRegister("clMpL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $8fdd0056ba595947$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $8fdd0056ba595947$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $8fdd0056ba595947$var$throwProtectedError;
var $8fdd0056ba595947$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $8fdd0056ba595947$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $8fdd0056ba595947$var$isProtectedDayOfYearToken(token) {
    return $8fdd0056ba595947$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $8fdd0056ba595947$var$isProtectedWeekYearToken(token) {
    return $8fdd0056ba595947$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $8fdd0056ba595947$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("72yv4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultOptions = $52037b4bd9689e56$var$getDefaultOptions;
module.exports.setDefaultOptions = $52037b4bd9689e56$var$setDefaultOptions;
var $52037b4bd9689e56$var$defaultOptions = {};
function $52037b4bd9689e56$var$getDefaultOptions() {
    return $52037b4bd9689e56$var$defaultOptions;
}
function $52037b4bd9689e56$var$setDefaultOptions(newOptions) {
    $52037b4bd9689e56$var$defaultOptions = newOptions;
}

});

parcelRegister("aVH97", function(module, exports) {

var $5mig0 = parcelRequire("5mig0");


var $kCJlM = parcelRequire("kCJlM");

const $c2424f4bc7159f1e$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $c2424f4bc7159f1e$var$id = (headers)=>headers;
async function $c2424f4bc7159f1e$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $c2424f4bc7159f1e$var$id) {
    return $c2424f4bc7159f1e$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $kCJlM.handleDirectoryGraphQLErrors));
}
async function $c2424f4bc7159f1e$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $c2424f4bc7159f1e$var$id) {
    return $c2424f4bc7159f1e$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $kCJlM.handleAGGErrors));
}
async function $c2424f4bc7159f1e$var$graphQLQuery(serviceUrl, query, processHeaders = $c2424f4bc7159f1e$var$id, handleErrors) {
    const headers = processHeaders($c2424f4bc7159f1e$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $5mig0.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}
module.exports["directoryGraphqlQuery"] = $c2424f4bc7159f1e$export$a5b5995619d4fe36;
module.exports["AGGQuery"] = $c2424f4bc7159f1e$export$a14afb5f82fe705;

});

parcelRegister("kmvqe", function(module, exports) {

var $9trs7 = parcelRequire("9trs7");

class $b272eafffdf5f2db$export$2e2bcd8739ae039 {
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
    constructor(config){
        this.config = void 0;
        this.cache = void 0;
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $9trs7.LRUMap)(this.config.cacheSize);
    }
}
module.exports["default"] = $b272eafffdf5f2db$export$2e2bcd8739ae039;

});

parcelRegister("kCJlM", function(module, exports) {

var $5mig0 = parcelRequire("5mig0");

const $af1466f9c996c258$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $af1466f9c996c258$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $af1466f9c996c258$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $af1466f9c996c258$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $5mig0.DirectoryGraphQLError)) return !!error && $af1466f9c996c258$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $5mig0.AGGError)) return !!error.errorType && $af1466f9c996c258$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $af1466f9c996c258$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $af1466f9c996c258$export$6ad9e7706a4ee0f8 = (error)=>{
    const defaultErrorAttributes = {
        errorCount: null,
        errorDetails: null,
        errorCategory: null,
        errorType: null,
        errorPath: null,
        errorNumber: null,
        errorStatusCode: null,
        traceId: null,
        errorStack: null
    };
    if (error instanceof (0, $5mig0.DirectoryGraphQLErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($af1466f9c996c258$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($af1466f9c996c258$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $5mig0.DirectoryGraphQLError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber ?? null,
        isSLOFailure: !$af1466f9c996c258$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $5mig0.AGGErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($af1466f9c996c258$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($af1466f9c996c258$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $5mig0.AGGError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorType: error.errorType ?? null,
        errorStatusCode: error.statusCode ?? null,
        isSLOFailure: !$af1466f9c996c258$var$isIgnoredError(error),
        errorCategory: error.classification ?? null
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $5mig0.DirectoryGraphQLErrors) || causeError instanceof (0, $5mig0.AGGErrors)) return $af1466f9c996c258$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                ...defaultErrorAttributes,
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            ...defaultErrorAttributes,
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        ...defaultErrorAttributes,
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $af1466f9c996c258$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $5mig0.DirectoryGraphQLErrors)(errors, traceId);
};
const $af1466f9c996c258$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $5mig0.AGGErrors)(errors, traceId);
};
module.exports["getErrorAttributes"] = $af1466f9c996c258$export$6ad9e7706a4ee0f8;
module.exports["handleDirectoryGraphQLErrors"] = $af1466f9c996c258$export$7642af465ceb7f05;
module.exports["handleAGGErrors"] = $af1466f9c996c258$export$d9ad65d422ee3f8c;

});

parcelRegister("78rLF", function(module, exports) {

var $bUp2E = parcelRequire("bUp2E");


var $caPHA = parcelRequire("caPHA");


var $kmvqe = parcelRequire("kmvqe");


var $kCJlM = parcelRequire("kCJlM");


var $fZXex = parcelRequire("fZXex");

class $08f53650ae3a713b$export$2e2bcd8739ae039 extends (0, $kmvqe.default) {
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $fZXex.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $caPHA.getPageTime)();
            if (analytics) analytics('operational.teamProfileCard.triggered.request', {
                firedAt: Math.round((0, $caPHA.getPageTime)()),
                ...(0, $bUp2E.PACKAGE_META_DATA)
            });
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics('operational.teamProfileCard.succeeded.request', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics('operational.teamProfileCard.failed.request', {
                    duration: (0, $caPHA.getPageTime)() - startTime,
                    ...(0, $kCJlM.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $caPHA.getPageTime)()),
                    ...(0, $bUp2E.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    constructor(options){
        super(options);
        this.options = void 0;
        this.options = options;
    }
}
module.exports["default"] = $08f53650ae3a713b$export$2e2bcd8739ae039;

});

parcelRegister("lfSOe", function(module, exports) {

var $hbEOA = parcelRequire("hbEOA");


var $bYUc2 = parcelRequire("bYUc2");

const $6739d59719e0930b$export$5921b2a93a401547 = ()=>{
    return (0, $hbEOA.isTeamsAppEnabled)({
        userHasNav4Enabled: (0, $bYUc2.getIsNav4EnabledSafe)(),
        hostProduct: 'confluence'
    });
};
module.exports["isTeamsAppEnabled"] = $6739d59719e0930b$export$5921b2a93a401547;

});

parcelRegister("4N3op", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $bYUc2 = parcelRequire("bYUc2");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isNav4Enabled = (0, $bYUc2.getIsNav4EnabledSafe)();
    return (0, $ay6Zz.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: isNav4Enabled,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("kHG3y", function(module, exports) {
$parcel$export(module.exports, "default", () => $f128724f052b3d2d$export$2e2bcd8739ae039);

var $6X2qU = parcelRequire("6X2qU");


var $icy6T = parcelRequire("icy6T");

var $f128724f052b3d2d$var$MILLISECONDS_IN_HOUR = 3600000;
var $f128724f052b3d2d$var$MILLISECONDS_IN_MINUTE = 60000;
var $f128724f052b3d2d$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $f128724f052b3d2d$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $f128724f052b3d2d$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $f128724f052b3d2d$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$f128724f052b3d2d$var$validateTimezone(hours)) return NaN;
        return -(hours * $f128724f052b3d2d$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $f128724f052b3d2d$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$f128724f052b3d2d$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $f128724f052b3d2d$var$MILLISECONDS_IN_HOUR + minutes * $f128724f052b3d2d$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($f128724f052b3d2d$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $f128724f052b3d2d$var$toUtcDate(date);
        var offset = $f128724f052b3d2d$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $f128724f052b3d2d$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $f128724f052b3d2d$var$toUtcDate(date) {
    return (0, $icy6T.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $f128724f052b3d2d$var$calcOffset(date, timezoneString) {
    var tokens = (0, $6X2qU.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $icy6T.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $f128724f052b3d2d$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $f128724f052b3d2d$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $f128724f052b3d2d$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $f128724f052b3d2d$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $f128724f052b3d2d$var$validIANATimezoneCache = {};
function $f128724f052b3d2d$var$isValidTimezoneIANAString(timeZoneString) {
    if ($f128724f052b3d2d$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $f128724f052b3d2d$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});

parcelRegister("5mig0", function(module, exports) {
class $3fe614271ff38656$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = void 0;
        this.traceId = void 0;
        this.code = code;
        this.traceId = traceId;
    }
}
class $3fe614271ff38656$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = void 0;
        this.type = void 0;
        this.path = void 0;
        this.errorNumber = void 0;
        this.extensions = void 0;
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $3fe614271ff38656$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $3fe614271ff38656$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $3fe614271ff38656$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = void 0;
        this.extensions = void 0;
        this.statusCode = void 0;
        this.errorType = void 0;
        this.classification = void 0;
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $3fe614271ff38656$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $3fe614271ff38656$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}
module.exports["HttpError"] = $3fe614271ff38656$export$65bd6083489bd8bb;
module.exports["DirectoryGraphQLError"] = $3fe614271ff38656$export$c1e4d0de940c06a2;
module.exports["DirectoryGraphQLErrors"] = $3fe614271ff38656$export$5a5fbfed34a590a1;
module.exports["AGGError"] = $3fe614271ff38656$export$4a696f048dcc929;
module.exports["AGGErrors"] = $3fe614271ff38656$export$60d8267243755b9c;

});

parcelRegister("6X2qU", function(module, exports) {
$parcel$export(module.exports, "default", () => $50fa23efd5005c77$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $50fa23efd5005c77$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $50fa23efd5005c77$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $50fa23efd5005c77$var$partsOffset(dtf, date) : $50fa23efd5005c77$var$hackyOffset(dtf, date);
}
var $50fa23efd5005c77$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $50fa23efd5005c77$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $50fa23efd5005c77$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $50fa23efd5005c77$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $50fa23efd5005c77$var$dtfCache = {};
function $50fa23efd5005c77$var$getDateTimeFormat(timeZone) {
    if (!$50fa23efd5005c77$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $50fa23efd5005c77$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $50fa23efd5005c77$var$dtfCache[timeZone];
}

});

parcelRegister("icy6T", function(module, exports) {
$parcel$export(module.exports, "default", () => $d403ce8772e54ffa$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $d403ce8772e54ffa$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});


$parcel$global.rlb("az9CK")
//# sourceMappingURL=mention.5d69355b.js.map
